var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Label as ThemeUILabel, } from 'theme-ui';
const Label = forwardRef((_a, ref) => {
    var { variant = 'label' } = _a, props = __rest(_a, ["variant"]);
    return _jsx(ThemeUILabel, Object.assign({ ref: ref, variant: variant }, props));
});
export default Label;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0xhYmVsL0xhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ25DLE9BQU8sRUFDTCxLQUFLLElBQUksWUFBWSxHQUV0QixNQUFNLFVBQVUsQ0FBQztBQUVsQixNQUFNLEtBQUssR0FBRyxVQUFVLENBQ3RCLENBQUMsRUFBK0IsRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUF4QyxFQUFFLE9BQU8sR0FBRyxPQUFPLE9BQVksRUFBUCxLQUFLLGNBQTdCLFdBQStCLENBQUY7SUFDNUIsT0FBTyxLQUFDLFlBQVksa0JBQUMsR0FBRyxFQUFFLEdBQUcsRUFBRSxPQUFPLEVBQUUsT0FBTyxJQUFNLEtBQUssRUFBSSxDQUFDO0FBQ2pFLENBQUMsQ0FDRixDQUFDO0FBRUYsZUFBZSxLQUFLLENBQUMifQ==